import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vueSmoothScroll from "vue-smooth-scroll";
import VueScrollTo from "vue-scrollto";

import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBvn7YmGBJjSxHdDC5CTfRxHZAJ_yjAp-Q",
  authDomain: "tachiai-8829c.firebaseapp.com",
  databaseURL: "https://tachiai-8829c.firebaseio.com",
  projectId: "tachiai-8829c",
  storageBucket: "tachiai-8829c.appspot.com",
  messagingSenderId: "428126829906",
  appId: "1:428126829906:web:7e3a1dc881372cfc"
};

firebase.initializeApp(firebaseConfig);
export const db = firebase.firestore();

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(BootstrapVue);
Vue.use(vueSmoothScroll);
Vue.use(VueScrollTo, {
  offset: -58
});
Vue.use(VueAwesomeSwiper /* { default global options } */);

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
